import { type DetailedHTMLProps, type FormHTMLAttributes, type ReactElement } from 'react'
import { cn } from '@util'

type Props = DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>

export const DrawerForm = ({ className, ...props }: Props): ReactElement => {
  return <form className={cn('relative flex flex-1 flex-col justify-between', className)} {...props} />
}
